import { DoricViewNode } from "./DoricViewNode";
var ScaleType;
(function (ScaleType) {
    ScaleType[ScaleType["ScaleToFill"] = 0] = "ScaleToFill";
    ScaleType[ScaleType["ScaleAspectFit"] = 1] = "ScaleAspectFit";
    ScaleType[ScaleType["ScaleAspectFill"] = 2] = "ScaleAspectFill";
})(ScaleType || (ScaleType = {}));
export class DoricImageNode extends DoricViewNode {
    build() {
        const ret = document.createElement('img');
        ret.style.objectFit = "fill";
        return ret;
    }
    blendProps(v, propName, prop) {
        switch (propName) {
            case 'imageUrl':
                v.setAttribute('src', prop);
                break;
            case 'imageBase64':
                v.setAttribute('src', prop);
                break;
            case 'loadCallback':
                v.onload = () => {
                    this.callJSResponse(prop, {
                        width: v.width,
                        height: v.height
                    });
                };
                break;
            case 'scaleType':
                switch (prop) {
                    case ScaleType.ScaleToFill:
                        v.style.objectFit = "fill";
                        break;
                    case ScaleType.ScaleAspectFit:
                        v.style.objectFit = "contain";
                        break;
                    case ScaleType.ScaleAspectFill:
                        v.style.objectFit = "cover";
                        break;
                }
                break;
            case 'isBlur':
                if (prop) {
                    v.style.filter = 'blur(8px)';
                }
                else {
                    v.style.filter = '';
                }
                break;
            default:
                super.blendProps(v, propName, prop);
                break;
        }
    }
}
//# sourceMappingURL=DoricImageNode.js.map